var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8957 7.81286C18.2295 7.47912 18.2295 6.93802 17.8957 6.60429C17.562 6.27055 17.0209 6.27055 16.6871 6.60429L12.5 10.7914L8.31286 6.60429C7.97912 6.27055 7.43802 6.27055 7.10429 6.60429C6.77055 6.93802 6.77055 7.47912 7.10429 7.81286L11.2914 12L7.10429 16.1871C6.77055 16.5209 6.77055 17.062 7.10429 17.3957C7.43802 17.7295 7.97912 17.7295 8.31286 17.3957L12.5 13.2086L16.6871 17.3957C17.0209 17.7295 17.562 17.7295 17.8957 17.3957C18.2295 17.062 18.2295 16.5209 17.8957 16.1871L13.7086 12L17.8957 7.81286Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.16cb70d247048cdab6f2c6818912d329.svg";
export { ForwardRef as ReactComponent };